import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from 'react';
import { useSetRecoilState } from 'recoil';
import { chatModalState, skipSurveyState } from '@/state/session';
import { WebviewResponse } from './Webview/WebviewResponse';
export const Survey = ({ survey, onButtonClick }) => {
    var _a;
    const setChatModal = useSetRecoilState(chatModalState);
    const setSkipSurvey = useSetRecoilState(skipSurveyState);
    const isCustomSurvey = !((_a = survey === null || survey === void 0 ? void 0 : survey.url) === null || _a === void 0 ? void 0 : _a.includes('moveo.ai'));
    useEffect(() => {
        if (isCustomSurvey) {
            setSkipSurvey(true);
        }
        else {
            setChatModal("survey" /* ChatModal.Survey */);
        }
    }, [survey, setChatModal, setSkipSurvey, isCustomSurvey]);
    const handleSurveyClick = (data) => {
        onButtonClick(Object.assign(Object.assign({}, data), { type: 'survey_button' }));
    };
    if (isCustomSurvey) {
        return (_jsx(WebviewResponse, { webview: survey, onButtonClick: handleSurveyClick }));
    }
    return null;
};
